// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3GcTi","list":"BalanceDue_list__2GSCI","listRow":"BalanceDue_listRow__pxdgx","total":"BalanceDue_total__3RvEj"};